import { GlossaryAssests } from './types/glossary.types';
import glossaryHeaderIcon from './assets/glossary-header-icon.svg';
import leftArrow from './assets/left-arrow.svg';

export const GLOSSARY_ASSETS: GlossaryAssests = {
  GLOSSARY_HEADER_ICON: glossaryHeaderIcon,
  LEFT_ARROW: leftArrow,
};
